import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";

export function IaxCheckField({ tfonchange, tfvalue, tflabel }) {
  return (
    <FormGroup variant="filled" sx={{ mb: 4 }} color="secondary">
      <FormControlLabel
        control={<Checkbox checked={tfvalue} />}
        label={tflabel}
        onChange={tfonchange}
        fullWidth
      />
    </FormGroup>
  );
}
